import { useCallback, useEffect, useRef } from "react";
import { editTableEntity } from "../utils";

export const useTableUpdateRowHeights = () => {
  "use no memo";
  const rafId = useRef<number | null>(null);

  const updateTableRowHeights = useCallback((heights: number[]) => {
    if (rafId.current) cancelAnimationFrame(rafId.current);
    rafId.current = requestAnimationFrame(() => {
      editTableEntity((draft) => {
        for (const idx in heights) {
          if (heights[idx] != null) {
            if (!draft.tableRowHeights) {
              draft.tableRowHeights = [];
            }
            draft.tableRowHeights[idx] = heights[idx];
          }
        }
      });
      rafId.current = null;
    });
  }, []);

  useEffect(() => {
    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, []);

  return { updateTableRowHeights };
};
